"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.array.reverse.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
var _teaComponent = require("@tencent/tea-component");
var _excluded = ["imageUrl", "hasMessage", "name", "className", "style", "dropdownProps", "reverse", "onClick", "dropdownPlace"];
// 在这里引入 tea-portal 组件，样式在 style/index.ts 中引入
// import Avatar from '@tencent/tea-portal/lib/Avatar';

// 在这里引入其他组件，样式在 style/index.ts 中引入
// import Button from '../Button';
var User = function User(props) {
  var imageUrl = props.imageUrl,
    hasMessage = props.hasMessage,
    name = props.name,
    className = props.className,
    style = props.style,
    dropdownProps = props.dropdownProps,
    reverse = props.reverse,
    onClick = props.onClick,
    _props$dropdownPlace = props.dropdownPlace,
    dropdownPlace = _props$dropdownPlace === void 0 ? 'bottom-start' : _props$dropdownPlace,
    extraProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('user');
  var classes = (0, _classnames.default)(prefixCls, className, {
    'is-reverse': reverse
  });
  var clickHandle = function clickHandle() {
    if (typeof onClick === 'function') {
      onClick();
    }
  };
  var avatarElement = /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__avatar"),
    onClick: function onClick() {
      clickHandle();
    }
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-user",
    style: {
      backgroundImage: imageUrl ? "url(".concat(imageUrl, ")") : undefined
    }
  }), !!hasMessage && /*#__PURE__*/_react.default.createElement("i", {
    className: "icon-badge"
  }));
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({
    className: classes,
    style: style
  }, extraProps), /*#__PURE__*/_react.default.createElement(_teaComponent.Dropdown, (0, _extends2.default)({
    trigger: "hover",
    clickClose: false,
    appearance: "pure",
    boxClassName: "size-h-xs  ".concat(prefixCls, "-dropdown-box")
  }, dropdownProps, {
    button: avatarElement,
    placement: dropdownPlace
  }), (dropdownProps === null || dropdownProps === void 0 ? void 0 : dropdownProps.children) || function (close) {
    return /*#__PURE__*/_react.default.createElement(_teaComponent.List, {
      type: "option"
    }, /*#__PURE__*/_react.default.createElement(_teaComponent.List.Item, {
      onClick: close,
      selected: true
    }, "\u6D3B\u52A8\u7A7A\u95F4"), /*#__PURE__*/_react.default.createElement(_teaComponent.List.Item, {
      onClick: close
    }, "\u5207\u6362\u8D26\u53F7"), /*#__PURE__*/_react.default.createElement(_teaComponent.List.Item, {
      onClick: close
    }, "\u9000\u51FA\u767B\u9646"));
  }), !!name && /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "__name")
  }, name));
};
var _default = User;
exports.default = _default;